var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import React, { useEffect, useState } from "react";
import { Row, Col, Button, Checkbox, MessageBanner, ConfirmationModal, } from "@folio/stripes/components";
import { useOkapiKy } from "@folio/stripes/core";
import { FormattedMessage, useIntl } from "react-intl";
import RenderField from "../../../components/RenderField";
import { convertRegistrationToContinuous } from "../../../api/publisherService";
import { sortRegistrationsActiveFirst, hasActiveRegistrationAtAgency, getRegistrationConversionRights, REGISTRATION_AGENCIES, } from "../../../utils/registrationUtils";
import { formatDate } from "../../../utils/dateTimeUtil";
import { usePermissions } from "../../../hooks/usePermissions";
import { useInvalidatePublisher } from "../../../hooks/usePublisherQuery";
import { AddRegistrationDialog } from "./AddRegistrationDialog";
import { FOREIGN_PUBLISHER_MESSAGE_ID, isForeignPublisherError, } from "../../../utils/publisherActionError";
export var RegistrationsSection = function (_a) {
    var _b;
    var publisher = _a.publisher, _c = _a.ownPublisher, ownPublisher = _c === void 0 ? false : _c, onConvertSuccess = _a.onConvertSuccess;
    var formatMessage = useIntl().formatMessage;
    var ky = useOkapiKy();
    var invalidatePublisher = useInvalidatePublisher();
    var _d = usePermissions(), canManagePublisherRegistrations = _d.canManagePublisherRegistrations, canConvertOwnPublisherRegistration = _d.canConvertOwnPublisherRegistration, canAddPublisherRegistration = _d.canAddPublisherRegistration;
    var conversionPermissions = {
        canManagePublisherRegistrations: canManagePublisherRegistrations,
        canConvertOwnPublisherRegistration: canConvertOwnPublisherRegistration,
    };
    var _e = useState(false), registerModalOpen = _e[0], setRegisterModalOpen = _e[1];
    var _f = useState(null), sectionError = _f[0], setSectionError = _f[1];
    var _g = useState(null), registrationToConvert = _g[0], setRegistrationToConvert = _g[1];
    var _h = useState(false), convertWithoutPrefixAssignment = _h[0], setConvertWithoutPrefixAssignment = _h[1];
    useEffect(function () {
        setSectionError(null);
    }, [publisher.id]);
    // the agency-only option "bez přidělení sady ISBN/ISMN" (DB-898)
    var canChooseWithoutPrefixAssignment = !!registrationToConvert &&
        getRegistrationConversionRights(registrationToConvert, conversionPermissions, ownPublisher).canChooseWithoutPrefixAssignment;
    var registrations = sortRegistrationsActiveFirst((_b = publisher.registrations) !== null && _b !== void 0 ? _b : []);
    var takenAgencies = REGISTRATION_AGENCIES.filter(function (agency) {
        return hasActiveRegistrationAtAgency(publisher, agency);
    });
    var hasAvailableAgency = takenAgencies.length < REGISTRATION_AGENCIES.length;
    var handleRegisterSuccess = function (updatedPublisher) {
        invalidatePublisher(updatedPublisher.id);
        setRegisterModalOpen(false);
    };
    var handleConvert = function () { return __awaiter(void 0, void 0, void 0, function () {
        var registration, updatedPublisher, error_1, _a, _b;
        var _c;
        return __generator(this, function (_d) {
            switch (_d.label) {
                case 0:
                    registration = registrationToConvert;
                    setRegistrationToConvert(null);
                    if (!publisher.id || !(registration === null || registration === void 0 ? void 0 : registration.id))
                        return [2 /*return*/];
                    setSectionError(null);
                    _d.label = 1;
                case 1:
                    _d.trys.push([1, 3, , 5]);
                    return [4 /*yield*/, convertRegistrationToContinuous(ky, publisher.id, registration.id, canChooseWithoutPrefixAssignment && convertWithoutPrefixAssignment)];
                case 2:
                    updatedPublisher = _d.sent();
                    invalidatePublisher(updatedPublisher.id);
                    onConvertSuccess === null || onConvertSuccess === void 0 ? void 0 : onConvertSuccess(updatedPublisher);
                    return [3 /*break*/, 5];
                case 3:
                    error_1 = _d.sent();
                    console.error("Error converting registration to continuous:", error_1);
                    _a = setSectionError;
                    _b = formatMessage;
                    _c = {};
                    return [4 /*yield*/, isForeignPublisherError(error_1)];
                case 4:
                    _a.apply(void 0, [_b.apply(void 0, [(_c.id = (_d.sent())
                                ? FOREIGN_PUBLISHER_MESSAGE_ID
                                : "ui-br-publishers.publishers.registrations.error.convertFailed",
                                _c)])]);
                    return [3 /*break*/, 5];
                case 5: return [2 /*return*/];
            }
        });
    }); };
    return (React.createElement(React.Fragment, null,
        sectionError && (React.createElement(MessageBanner, { type: "error", dismissible: true, onExit: function () { return setSectionError(null); } }, sectionError)),
        registrations.length === 0 ? (React.createElement(Row, null,
            React.createElement(Col, { xs: 12 },
                React.createElement("div", null, formatMessage({
                    id: "ui-br-publishers.publishers.registrations.empty",
                }))))) : (registrations.map(function (registration, index) {
            var _a;
            var isActive = !registration.terminationTime;
            var canConvert = getRegistrationConversionRights(registration, conversionPermissions, ownPublisher).canConvert;
            return (React.createElement("div", { key: (_a = registration.id) !== null && _a !== void 0 ? _a : index, className: index > 0 ? "registration-row" : undefined, style: index > 0
                    ? {
                        borderTop: "1px solid #dfe1e6",
                        paddingTop: "0.5rem",
                        marginTop: "0.5rem",
                    }
                    : undefined },
                React.createElement(Row, null,
                    React.createElement(Col, { xs: 6, sm: 4 },
                        React.createElement(RenderField, { label: formatMessage({
                                id: "ui-br-publishers.publishers.registrations.field.label.agency",
                            }), value: registration.registrationAgency })),
                    React.createElement(Col, { xs: 6, sm: 4 },
                        React.createElement(RenderField, { label: formatMessage({
                                id: "ui-br-publishers.publishers.registrations.field.label.intent",
                            }), value: registration.registrationIntent
                                ? formatMessage({
                                    id: "ui-br-publishers.publishers.registrations.intent.".concat(registration.registrationIntent.toLowerCase()),
                                })
                                : undefined })),
                    React.createElement(Col, { xs: 6, sm: 4 },
                        React.createElement(RenderField, { label: formatMessage({
                                id: "ui-br-publishers.publishers.registrations.field.label.state",
                            }), value: formatMessage({
                                id: isActive
                                    ? "ui-br-publishers.publishers.registrations.state.active"
                                    : "ui-br-publishers.publishers.registrations.state.terminated",
                            }) })),
                    React.createElement(Col, { xs: 6, sm: 4 },
                        React.createElement(RenderField, { label: formatMessage({
                                id: "ui-br-publishers.publishers.registrations.field.label.registrationTime",
                            }), value: registration.registrationTime
                                ? formatDate(registration.registrationTime)
                                : undefined })),
                    React.createElement(Col, { xs: 6, sm: 4 },
                        React.createElement(RenderField, { label: formatMessage({
                                id: "ui-br-publishers.publishers.registrations.field.label.terminationTime",
                            }), value: registration.terminationTime
                                ? formatDate(registration.terminationTime)
                                : undefined }))),
                canConvert && (React.createElement(Row, null,
                    React.createElement(Col, { xs: 12 },
                        React.createElement(Button, { onClick: function () {
                                setRegistrationToConvert(registration);
                                setConvertWithoutPrefixAssignment(false);
                            }, marginBottom0: true },
                            React.createElement(FormattedMessage, { id: "ui-br-publishers.publishers.registrations.button.convertToContinuous", values: { agency: registration.registrationAgency } })))))));
        })),
        canAddPublisherRegistration && hasAvailableAgency && (React.createElement(Row, null,
            React.createElement(Col, { xs: 12 },
                React.createElement(Button, { onClick: function () { return setRegisterModalOpen(true); } },
                    React.createElement(FormattedMessage, { id: "ui-br-publishers.publishers.registrations.button.registerAnotherAgency" }))))),
        React.createElement(AddRegistrationDialog, { open: registerModalOpen, publisherId: publisher.id, takenAgencies: takenAgencies, onClose: function () { return setRegisterModalOpen(false); }, onSuccess: handleRegisterSuccess }),
        React.createElement(ConfirmationModal, { open: !!registrationToConvert, bodyTag: "div", heading: formatMessage({
                id: "ui-br-publishers.publishers.registrations.confirm.convert.heading",
            }), message: React.createElement(React.Fragment, null,
                formatMessage({
                    id: "ui-br-publishers.publishers.registrations.confirm.convert.message",
                }),
                canChooseWithoutPrefixAssignment && (React.createElement(Checkbox, { label: formatMessage({
                        id: "ui-br-publishers.publishers.registrations.checkbox.withoutPrefixAssignment",
                    }), checked: convertWithoutPrefixAssignment, onChange: function (e) {
                        return setConvertWithoutPrefixAssignment(e.target.checked);
                    } }))), onConfirm: handleConvert, onCancel: function () { return setRegistrationToConvert(null); }, confirmLabel: formatMessage({
                id: "ui-br-publishers.button.continue",
            }), cancelLabel: formatMessage({ id: "ui-br-publishers.button.cancel" }), buttonStyle: "primary" })));
};
